import { PipeTransform, Pipe } from '@angular/core';
import { pipe } from 'rxjs';
import { UserStates } from '../models/userstate.model';
import { User } from '../models/user.model';

@Pipe({
    name: 'estadosFilter'
})

export class EstadosFilterPipe implements PipeTransform {
  transform(items: UserStates[], args: any) {
    if (args.hasOwnProperty('fkUserState') && typeof items != 'undefined'){
        return items.filter(item => item.idUserState == args.fkUserState)[0].userStateName;
        }
        return "Sin Estado"
    }      
}

